import { getStoreId } from "$/hooks/use-store-information"
import addonOrderQueries from "$/lib/queries/addon-order-queries"
import feeQueries from "$/lib/queries/fee-queries"
import jobQueries from "$/lib/queries/job-queries"
import partQueries from "$/lib/queries/part-queries"
import properInspectionQueries from "$/lib/queries/proper-inspection-queries"
import washQueries from "$/lib/queries/wash-queries"
import { requireStoreFeature } from "$/lib/require-store-feature"
import { JobStatus, STORE_FEATURE } from "@repo/common"
import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from "@tanstack/react-router"
import { fallback, zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

const properInspectionSearchSchema = z.object({
  partId: fallback(z.string().uuid(), "").default(""),
})

export const Route = createFileRoute("/(app)/_auth/jobs/$jobId/inspection")({
  gcTime: 0,
  loader: async ({ context: { queryClient }, params }) => {
    await requireStoreFeature(queryClient, STORE_FEATURE.INSPECTION)

    const { jobId } = params

    const job = await queryClient.fetchQuery(jobQueries.detail(jobId))

    if (job.status === JobStatus.SERVICE_PROPOSAL_SENT) {
      throw redirect({ to: "/jobs/$jobId", params: { jobId } })
    }

    const addonOrderHistory = await queryClient.fetchQuery(
      addonOrderQueries.history(jobId),
    )
    const hasPendingAddonOrder = addonOrderHistory.orders.some(
      (order) => order.status === "pending",
    )

    if (hasPendingAddonOrder) {
      throw redirect({ to: "/jobs/$jobId", params: { jobId } })
    }

    const storeId = await getStoreId()

    if (storeId) {
      queryClient.prefetchQuery(partQueries.list({ storeId }))
      queryClient.prefetchQuery(washQueries.list({ storeId }))
      queryClient.prefetchQuery(feeQueries.list({ storeId }))
    }

    return {
      crumb: "alfred.jobs.inspection.crumb",
      requiredData: await queryClient.fetchQuery(
        properInspectionQueries.detail(jobId),
      ),
    }
  },
  search: {
    middlewares: [stripSearchParams({ partId: "" })],
  },
  validateSearch: zodValidator(properInspectionSearchSchema),
})
